import { Routes } from '@angular/router';
import { ListClientsComponent } from './ClientSection/list-clients/list-clients.component';
import { ExpedierMemberComponent } from './ClientSection/expedier-member/expedier-member.component';
import { EstimerTarifComponent } from './ClientSection/estimer-tarif/estimer-tarif.component';
import { EstimerTempsTransitComponent } from './ClientSection/estimer-temps-transit/estimer-temps-transit.component';
import { HistoriqueEnvoisComponent } from './ClientSection/historique-envois/historique-envois.component';

export const WebsiteRoutes: Routes = [
  { path: 'clients-liste', component: ListClientsComponent },
      {
        path: 'expedier-comme-membre',
        component: ExpedierMemberComponent
      },
      { path: 'estimer-tarif', component: EstimerTarifComponent },
      { path: 'temps-transit', component: EstimerTempsTransitComponent },
      { path: 'historique', component: HistoriqueEnvoisComponent }
]
